import * as React from 'react';
import UprinceNavigation from '../../shared/uprinceNavigation/cuProjectNavigation/component';
import { getContractingUnit } from '../../shared/util';
import { FluentProvider, teamsLightTheme } from '@fluentui/react-components';
import WbsCuTaskMainLayout from './WbsCuTaskMainLayout';

const WbsCuTask = (props: { currentUser: any }) => {

  return (
    <>
      <UprinceNavigation
        currentUser={props.currentUser}
        selectedNavigationIndex={`/CU/${getContractingUnit()}/wbs-cu-task`}
      >
        <FluentProvider theme={teamsLightTheme}>
          <WbsCuTaskMainLayout />
        </FluentProvider>
      </UprinceNavigation>
    </>
  );

};

export default WbsCuTask;
